import { render, staticRenderFns } from "./shopCheckPaymentFailed.vue?vue&type=template&id=3e9f81f6"
import script from "./shopCheckPaymentFailed.vue?vue&type=script&lang=js"
export * from "./shopCheckPaymentFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports